import React from 'react';

import { Tooltip } from 'components/tooltip';
import { UserManagerService } from 'modules/userManager';
import PropTypes from 'prop-types';

const TooltipReason = ({ reason, children }) => {
  const { type, text } = reason;

  return (
    <div className="user-info-tooltip">
      <Tooltip
        position="top"
        alignment="center"
        mode="light"
        text={UserManagerService.getReasonLabel(type)}
        justText={text}
      >
        {children}
      </Tooltip>
    </div>
  );
};

TooltipReason.propTypes = {
  reason: PropTypes.shape({
    type: PropTypes.string.isRequired,
    text: PropTypes.string
  }),
  children: PropTypes.any
};

export default TooltipReason;
